<template>
  <div class="container">
    <!-- <button style="width:100px;height:100px" @click="change"></button> -->
    <!--标题和袋迪图标-->
    <div class="title">
      <div class="daidi-icon">
        <div class="daidi-ini" v-if="status === 1"></div>
        <div class="daidi-win" v-if="status === 2"></div>
        <div class="daidi-lose" v-if="status === 3"></div>
      </div>
      <div class="poster"></div>
    </div>

    <!-- 游戏机界面 -->
    <div class="play-mechine">
      <div class="screen">
        <!--第一次进去时候屏幕显示-->
        <div class="screen-ini" v-if="gameProgress === 1"></div>

        <!--出拳之后屏幕变化-->
        <div class="game-start" v-if="gameProgress === 2">
          <div class="left">
            <div class="rock-player" v-if="customerChoose === 1"></div>
            <div class="paper-player" v-if="customerChoose === 2"></div>
            <div class="scissor-player" v-if="customerChoose === 3"></div>
          </div>

          <div class="mid">
            <div class="mid-icon"></div>
          </div>

          <div class="right">
            <div class="rock-GM" v-if="systemChoose === 1"></div>
            <div class="paper-GM" v-if="systemChoose === 2"></div>
            <div class="scissor-GM" v-if="systemChoose === 3"></div>
          </div>
        </div>

        <!--后端放回结果页面-->
        <div class="game-end" v-if="gameProgress === 3 || gameProgress === 5">
          <div class="left">
            <div class="rock-result" v-if="customerChoose === 1">
              <div class="rock-player" v-if="gameResult === 1 || gameResult ===4"></div>
              <div class="rock-player-gray" v-if="gameResult === 2 || gameResult ===3 || gameResult === 5"></div>
            </div>
            <div class="paper-result" v-if="customerChoose === 2">
              <div class="paper-player" v-if="gameResult === 1 || gameResult ===4"></div>
              <div class="paper-player-gray" v-if="gameResult === 2 || gameResult ===3 || gameResult === 5"></div>
            </div>
            <div class="scissor-result" v-if="customerChoose === 3">
              <div class="scissor-player" v-if="gameResult === 1 || gameResult ===4"></div>
              <div class="scissor-player-gray" v-if="gameResult === 2 || gameResult ===3 || gameResult === 5"></div>
            </div>
          </div>

          <div class="result-slogen" v-if="gameProgress !== 5">
            <div class="win" v-if="gameResult === 1"></div>
            <div class="equal" v-if="gameResult === 2"></div>
            <div class="lose" v-if="gameResult === 3"></div>
          </div>

          <div class="mid">
            <div class="mid-icon"></div>
          </div>

          <div class="right">
            <div class="rock-result" v-if="systemChoose === 1">
              <div
                  class="rock-GM"
                  v-if="gameResult === 2 || gameResult === 3 || gameResult ===4"
              ></div>
              <div class="rock-GM-gray" v-if="gameResult === 1 || gameResult ===5"></div>
            </div>
            <div class="paper-result" v-if="systemChoose === 2 ">
              <div
                  class="paper-GM"
                  v-if="gameResult === 2 || gameResult === 3 || gameResult ===4"
              ></div>
              <div class="paper-GM-gray" v-if="gameResult === 1 || gameResult ===5"></div>
            </div>
            <div class="scissor-result" v-if="systemChoose === 3">
              <div
                  class="scissor-GM"
                  v-if="gameResult === 2 || gameResult === 3 || gameResult ===4"
              ></div>
              <div class="scissor-GM-gray" v-if="gameResult === 1 || gameResult ===5"></div>
            </div>
          </div>

          <div class="result-tip" v-if="gameProgress !== 5">
            <div v-if="gameResult === 1" class="tip-win"></div>
            <div v-if="gameResult === 3" class="tip-lose"></div>
            <div v-if="gameResult === 2" class="tip-draw"></div>
          </div>
        </div>

        <div class="error" v-if="gameProgress === 4">
          -啊噢，网络出错了-
        </div>
      </div>

      <!--按钮-->
      <div class="chooseButton" v-if="gameProgress === 1 || gameProgress === 2 || gameProgress === 5">
        <div class="rock-button">
          <div
              class="rock-unpress"
              v-if="rockPress"
              @click="chooseFinger(1)"
          ></div>
          <div class="rock-press" v-else></div>
        </div>
        <div class="scissor-button">
          <div
              class="scissor-unpress"
              v-if="scissorPress"
              @click="chooseFinger(3)"
          ></div>
          <div class="scissor-press" v-else></div>
        </div>
        <div class="paper-button">
          <div
              class="paper-unpress"
              v-if="paperPress"
              @click="chooseFinger(2)"
          ></div>
          <div class="paper-press" v-else></div>
        </div>
      </div>
      <div class="result-button" v-if="gameProgress === 3 || gameProgress === 4">
        <div class="win-button" v-if="gameResult === 1" @click="goListen()">
          {{ audioId ? '马上去听' : '马上观看' }}
        </div>
        <template v-if="gameResult === 2 || gameResult === 3 || gameResult === 4">
          <div class="lose-button" v-if="canPlay === true" @click="goPlay()">
            再玩一次
          </div>
          <div class="lose-button" v-if="canPlay === false && (audioId ? isVip ==='1' : isVip === '2')"
               @click="goNumber()">
            开通会员,马上{{ audioId ? '收听' : '观看' }}
          </div>
          <div class="lose-single-button" v-if="canPlay === false && (audioId ? isVip ==='2' : isVip === '3') "
               @click="goPaySingle()">
            购买故事,马上{{ audioId ? '收听' : '观看' }}
          </div>
        </template>
      </div>
      <!-- 退出键 -->
      <div class="quit" @click="quit()" v-if="gameResult !== 1">
        退出
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {sendTraceLog} from '@/api/trace'
import {getGameResult, getGametimes, getGameVideoResult} from '@/api/fingerGuess'
import config from '@/config/config'

export default {
  data() {
    return {
      reasons: false,
      flag: true,
      leftTime: null,
      lotteryId: null,
      errchoose: 0,
      open: false,
      status: 1, // 顶部袋迪状态
      customerChoose: 0, // 用户的猜拳选择
      gameProgress: 1, // 游戏进程
      systemChoose: 0, //系统猜拳选择
      gameResult: 0, // 输赢结果
      rockPress: true, // 拳头
      scissorPress: true, //剪刀
      paperPress: true, // 布
      pressed: false, //是否按下
      win: true, //输赢
      canPlay: true, // 还能不能继续玩 是否还有次数
      audio: '',
      chapter: '',
      flashopen: 4,
      audioUrl: {
        start: 'https://img-ilisten.idaddy.cn/fingerGuess/start.mp3',
        buttonPress: 'https://img-ilisten.idaddy.cn/fingerGuess/buttonpress.mp3',
        win: 'https://img-ilisten.idaddy.cn/fingerGuess/audio_win.mp3',
        lose: 'https://img-ilisten.idaddy.cn/fingerGuess/lose.mp3',
        draw: 'https://img-ilisten.idaddy.cn/fingerGuess/drawn.mp3'
      }
    }
  },
  created() {
    const {audio_ids = '', video_ids = '', goodID = ''} = this.$route.query
    if (audio_ids) {
      this.audioId = audio_ids.split('_')[0]
      this.chapterId = audio_ids.split('_')[1]
    } else if (video_ids) {
      this.videoId = video_ids.split('_')[0]
      this.chapterId = video_ids.split('_')[1]
      this.audioUrl.win = 'https://img-ilisten.idaddy.cn/fingerGuess/video_win.mp3'
    } else {
      this.$toast.show({
        text: '缺少音频或视频ID~',
        duration: 3000
      })
      return
    }
    this.goodsId = goodID
    this.getenviroment()
    this.setTraceLog()
    // this.getGmeTime()
    window.androidClickKeyBack = function () {
      window.location.href = '/exitInWebView'
    }
  },
  mounted() {
    this.playAudio(this.audioUrl.start)
    setTimeout(() => {
      new Image('@/assets/game-title.png')
      new Image('@/assets/icon-bg.png')
      new Image('@/assets/icon-button.png')
      new Image('@/assets/icon-daidi-ini.png')
      new Image('@/assets/icon-daidi-lose.png')
      new Image('@/assets/icon-daidi-win.png')
      new Image('@/assets/icon-lose-one.png')
      new Image('@/assets/icon-lose-two.png')
      new Image('@/assets/icon-paper-unpress.png')
      new Image('@/assets/icon-paper-press.png')
      new Image('@/assets/icon-poster.png')
      new Image('@/assets/icon-rock-press.png')
      new Image('@/assets/icon-rock-unpress.png')
      new Image('@/assets/icon-scissor-press.png')
      new Image('@/assets/icon-scissor-unpress.png')
      new Image('@/assets/icon-vs.png')
      new Image('@/assets/icon-win-tip.png')
      new Image('@/assets/icon-win.png')
      new Image('@/assets/paper-gm-gray.png')
      new Image('@/assets/paper-gm.png')
      new Image('@/assets/paper-player-gray.png')
      new Image('@/assets/paper-player.png')
      new Image('@/assets/play-machine.png')
      new Image('@/assets/rock-gm-gray.png')
      new Image('@/assets/rock-gm.png')
      new Image('@/assets/rock-player-gray.png')
      new Image('@/assets/rock-player.png')
      new Image('@/assets/scissor-gm-gray.png')
      new Image('@/assets/scissor-gm.png')
      new Image('@/assets/scissor-player-gray.png')
      new Image('@/assets/scissor-player.png')
    }, 0)
  },
  methods: {
    getenviroment() {
      this.lotteryId = this.audioId ? 2 : 27
      // if(config.env === 'dev'){
      //   this.lotteryId = 2
      // }
      if (config.env === 'wt2' && !this.audioId) {
        this.lotteryId = 8
      }
      // if(config.env === 'wt1'){
      //   this.lotteryId = 2
      // }
      // if(config.env === 'prod'){
      //   this.lotteryId = 2
      // }
    },
    setTraceLog() {
      if (this.audioId) {
        this.traceType = {
          audio_type: this.isVip === '1' ? 'vip_audio' : 'vvip_audio'
        }
      } else {
        this.traceType = {
          video_type: this.isVip === '2' ? 'vip_video' : 'vvip_video'
        }
      }
    },
    async chooseFinger(x) {
      // 点击猜拳开始 分别对应三种情况
      if (this.pressed === true) return
      if (x === 1) {
        this.errchoose = 1
        this.playAudio(this.audioUrl.buttonPress)
        this.gameProgress = 2
        this.rockPress = false
        this.pressed = true
        // 开始随机
        this.gameProgress = 5
        this.gameResult = 4
        let that = this
        const timer = setInterval(function () {
          that.customerChoose = parseInt(Math.random() * 3 + 1)
          that.systemChoose = parseInt(Math.random() * 3 + 1)
        }, 88)
        await this.getResult()
        window.clearInterval(timer)
        this.customerChoose = 1

        //log: 猜拳行为
        sendTraceLog('treat_play', {
          ...this.traceType,
          audio_id: this.audioId,
          video_id: this.videoId,
          chapter_id: this.chapterId,
          left_times: this.leftTime,
          lottery_id: this.lotteryId,
          choose: 'rock'
        }, this.userId)

        if (this.win) {
          this.systemChoose = 3
          this.flash(1, 3)
          let that = this
          setTimeout(() => {
            that.playAudio(this.audioUrl.win)
            that.open = true
            that.status = 2
            that.gameProgress = 3
            that.gameResult = 1
            //log: 猜拳结果
            sendTraceLog('treat_result', {
              ...this.traceType,
              audio_id: this.audioId,
              video_id: this.videoId,
              chapter_id: this.chapterId,
              left_times: this.leftTime,
              lottery_id: this.lotteryId,
              status: 'win',
            }, this.userId)
          }, 1000)
        } else {
          let result = this.getRandom()
          if (result <= 5) {
            this.systemChoose = 1
            this.flash(1, 1)
            let that = this
            setTimeout(() => {
              that.playAudio(this.audioUrl.draw)
              that.open = true
              that.status = 3
              that.gameResult = 2
              that.gameProgress = 3
              sendTraceLog('treat_result', {
                ...this.traceType,
                audio_id: this.audioId,
                video_id: this.videoId,
                chapter_id: this.chapterId,
                left_times: this.leftTime,
                lottery_id: this.lotteryId,
                status: 'draw',
                failed_reasons: this.reasons
              }, this.userId)
            }, 1000)
          } else {
            this.systemChoose = 2
            this.flash(1, 2)
            let that = this
            setTimeout(() => {
              that.playAudio(this.audioUrl.lose)
              that.open = true
              that.status = 3
              that.gameProgress = 3
              that.gameResult = 3
              sendTraceLog('treat_result', {
                ...this.traceType,
                audio_id: this.audioId,
                video_id: this.videoId,
                chapter_id: this.chapterId,
                left_times: this.leftTime,
                lottery_id: this.lotteryId,
                status: 'lost',
                failed_reasons: this.reasons
              }, this.userId)
            }, 1000)
          }
        }
      }
      if (x === 2) {
        this.errchoose = 2
        this.playAudio(this.audioUrl.buttonPress)
        this.paperPress = false
        this.pressed = true
        this.gameProgress = 2
        // 开始随机
        this.gameProgress = 5
        this.gameResult = 4
        let that = this
        const timer = setInterval(function () {
          that.customerChoose = parseInt(Math.random() * 3 + 1)
          that.systemChoose = parseInt(Math.random() * 3 + 1)
        }, 88)
        await this.getResult()
        window.clearInterval(timer)
        this.customerChoose = 2

        //log: 猜拳行为
        sendTraceLog('treat_play', {
          ...this.traceType,
          audio_id: this.audioId,
          video_id: this.videoId,
          chapter_id: this.chapterId,
          left_times: this.leftTime,
          lottery_id: this.lotteryId,
          choose: 'paper'
        }, this.userId)

        if (this.win) {
          this.systemChoose = 1
          this.flash(2, 1)
          let that = this
          setTimeout(() => {
            that.playAudio(this.audioUrl.win)
            that.open = true
            that.gameProgress = 3
            that.gameResult = 1
            that.status = 2
            //log: 猜拳结果
            sendTraceLog('treat_result', {
              ...this.traceType,
              audio_id: this.audioId,
              video_id: this.videoId,
              chapter_id: this.chapterId,
              left_times: this.leftTime,
              lottery_id: this.lotteryId,
              status: 'win',
            }, this.userId)
          }, 1000)
        } else {
          let result = this.getRandom()
          if (result <= 5) {
            this.systemChoose = 2
            this.flash(2, 2)
            let that = this
            setTimeout(() => {
              that.playAudio(this.audioUrl.draw)
              that.open = true
              that.gameResult = 2
              that.status = 3
              that.gameProgress = 3
              //log: 猜拳结果
              sendTraceLog('treat_result', {
                ...this.traceType,
                audio_id: this.audioId,
                video_id: this.videoId,
                chapter_id: this.chapterId,
                left_times: this.leftTime,
                lottery_id: this.lotteryId,
                status: 'draw',
                failed_reasons: this.reasons
              }, this.userId)
            }, 1000)
          } else {
            this.systemChoose = 3
            this.flash(2, 3)
            let that = this
            setTimeout(() => {
              that.playAudio(this.audioUrl.lose)
              that.open = true
              that.gameResult = 3
              that.status = 3
              that.gameProgress = 3
              sendTraceLog('treat_result', {
                ...this.traceType,
                audio_id: this.audioId,
                video_id: this.videoId,
                chapter_id: this.chapterId,
                left_times: this.leftTime,
                lottery_id: this.lotteryId,
                status: 'lost',
                failed_reasons: this.reasons
              }, this.userId)
            }, 1000)
          }
        }
      }
      if (x === 3) {
        this.errchoose = 3
        this.playAudio(this.audioUrl.buttonPress)
        this.scissorPress = false
        this.pressed = true
        this.gameProgress = 2
        // 开始随机
        this.gameProgress = 5
        this.gameResult = 4
        let that = this
        const timer = setInterval(function () {
          that.customerChoose = parseInt(Math.random() * 3 + 1)
          that.systemChoose = parseInt(Math.random() * 3 + 1)
        }, 88)
        window.clearInterval(timer)
        await this.getResult()
        this.customerChoose = 3

        //log: 猜拳行为
        sendTraceLog('treat_play', {
          ...this.traceType,
          audio_id: this.audioId,
          video_id: this.videoId,
          chapter_id: this.chapterId,
          left_times: this.leftTime,
          lottery_id: this.lotteryId,
          choose: 'scissors'
        }, this.userId)

        if (this.win) {
          this.systemChoose = 2
          this.flash(3, 2)
          let that = this
          setTimeout(() => {
            that.playAudio(this.audioUrl.win)
            that.open = true
            that.gameResult = 1
            that.gameProgress = 3
            that.status = 2
            //log: 猜拳结果
            sendTraceLog('treat_result', {
              ...this.traceType,
              audio_id: this.audioId,
              video_id: this.videoId,
              chapter_id: this.chapterId,
              left_times: this.leftTime,
              lottery_id: this.lotteryId,
              status: 'win',
            }, this.userId)
          }, 1000)
        } else {
          let result = this.getRandom()
          if (result <= 5) {
            this.systemChoose = 3
            this.flash(3, 3)
            let that = this
            setTimeout(() => {
              that.playAudio(this.audioUrl.draw)
              that.open = true
              that.gameResult = 2
              that.gameProgress = 3
              that.status = 3
              sendTraceLog('treat_result', {
                ...this.traceType,
                audio_id: this.audioId,
                video_id: this.videoId,
                chapter_id: this.chapterId,
                left_times: this.leftTime,
                lottery_id: this.lotteryId,
                status: 'draw',
                failed_reasons: this.reasons
              }, this.userId)
            }, 1000)
          } else {
            this.systemChoose = 1
            this.flash(3, 1)
            let that = this
            setTimeout(() => {
              that.playAudio(this.audioUrl.lose)
              that.open = true
              that.gameResult = 3
              that.gameProgress = 3
              that.status = 3
              sendTraceLog('treat_result', {
                ...this.traceType,
                audio_id: this.audioId,
                video_id: this.videoId,
                chapter_id: this.chapterId,
                left_times: this.leftTime,
                lottery_id: this.lotteryId,
                status: 'lost',
                failed_reasons: this.reasons
              }, this.userId)
            }, 1000)
          }
        }
      }
    },
    getRandom() {
      // 通过随机数去控制 在你输了的时候，是输还是平局
      return Math.floor(Math.random() * 10 + 1)
    },
    async getResult() {
      let that = this
      setTimeout(() => {
        that.flag = false
      }, 3000)
      try {
        let result
        if (this.audioId) {
          result = await getGameResult(this.audioId, this.chapterId, this.lotteryId)
        }
        if (this.videoId) {
          result = await getGameVideoResult(this.videoId, this.chapterId, this.lotteryId)
        }
        if (!this.flag) {
          this.reasons = 'timeout'
          this.win = false
          return
        }
        let time = await this.getGmeTime()
        if (time === false) return
        let win1, win2
        if (result.data.win === 2) {
          this.win = false
          if (result.data.code === 103) {
            this.reasons = 'nochance'
          } else {
            this.reasons = 'lost'
          }
          return
        }
        let index
        if (this.audioId) {
          index = result.data.chapter_auth_info.success.findIndex(
              (item) => item == this.chapterId
          )
        }
        if (this.videoId) {
          index = result.data.video_chapter_auth_info.success.findIndex(
              (item) => item == this.chapterId
          )
        }
        if (index > -1) {
          win1 = true
        } else {
          win1 = false
          this.reasons = 'lost'
        }

        let chap
        if (this.audioId) {
          chap = result.data.audio_auth_info.success.findIndex(
              (item) => item == this.audioId
          )
        }
        if (this.videoId) {
          chap = result.data.video_auth_info.success.findIndex(
              (item) => item == this.videoId
          )
        }
        if (chap > -1) {
          win2 = true
        } else {
          win2 = false
        }
        if (win1 === false && win2 === false) {
          this.win = false
          this.reasons = 'lost'
        } else {
          this.win = true
        }
      } catch (err) {
        if (!this.flag) {
          this.reasons = 'timeout'
          this.win = false
          return
        }
        this.reasons = 'timeout'
        this.win = false
      }
    },
    // async getGameResult() {
    // // 在开始的时候,我们首先获取这个游戏的结果
    // try{
    //   let result = await getGameResult(this.audioId, this.chapterId, this.lotteryId)
    //   let time = await this.getGmeTime()
    //   if(time === false) return
    //   let win1 , win2
    //   if(result.data.win ===2) {
    //     this.win= false
    //     return
    //   }
    //   let index = result.data.chapter_auth_info.success.findIndex(
    //     (item) => item == this.chapterId
    //   )
    //   if (index > -1) {
    //     win1 = true
    //   } else {
    //     win1 = false
    //   }

    //   let chap = result.data.audio_auth_info.success.findIndex(
    //     (item) => item == this.audioId
    //   )
    //   if (chap > -1) {
    //     win2 = true
    //   } else {
    //     win2 = false
    //   }
    //   if (win1 === false && win2 === false) {
    //     this.win= false
    //   }else{
    //     this.win = true
    //   }
    // } catch(error) {
    //     this.win = false
    // }
    // },
    async getGmeTime() {
      // 获取游戏次数
      try {
        let result = await getGametimes(this.lotteryId)
        if (result.data.max_draw_num < 0) {
          this.canPlay = true
        } else {
          let times = result.data.max_draw_num - result.data.current_draw_num
          if (times > 0) {
            this.leftTime = times
            this.canPlay = true
          } else {
            this.leftTime = 0
            this.canPlay = false
          }
        }
      } catch (error) {
        this.reasons = 'timeout'
        this.win = false
      }
    },
    flash(customerChoose, systemChoose) {
      if (this.open) {
        return
      }
      this.customerChoose = customerChoose
      this.systemChoose = systemChoose
      this.gameResult = parseInt(Math.random() * (2) + 4, 10)
      let that = this
      let timer = setTimeout(() => {
        that.flash(that.customerChoose, that.systemChoose)
      }, 80)
    },
    goListen() {
      // 赢了之后操作
      try {
        if (this.audioId) {
          window.ibridge.callHandler('auth.chapter', {
            storyId: this.audioId,
            chapterId: this.chapterId,
            objType: 'audio'
          }, () => {
            window.ibridge.callHandler('player.playChapter', {
              storyId: this.audioId,
              chapterId: this.chapterId,
              objType: 'audio'
            }, (res) => {
              console.log('bridge res:', res)
            })
          })
        }
        if (this.videoId) {
          window.ibridge.callHandler('auth.chapter', {
            storyId: this.videoId,
            chapterId: this.chapterId,
            objType: 'video'
          }, () => {
            window.ibridge.callHandler('player.playChapter', {
              storyId: this.videoId,
              chapterId: this.chapterId,
              objType: 'video'
            }, (res) => {
              console.log('bridge res:', res)
            })
          })
        }
        // log: 知道结果之后的操作
        sendTraceLog('treat_operation', {
          ...this.traceType,
          audio_id: this.audioId,
          video_id: this.videoId,
          chapter_id: this.chapterId,
          status: 'win',
          event_type: 'play_audio'
        }, this.userId)
        setTimeout(() => {
          window.location.href = '/exitInWebView'
        }, 1000)
      } catch (err) {
        console.log(err)
      }
    },
    async goPlay() {
      // 再玩一次

      // log: 知道结果之后的操作
      sendTraceLog('treat_operation', {
        ...this.traceType,
        audio_id: this.audioId,
        video_id: this.videoId,
        chapter_id: this.chapterId,
        status: this.gameResult === 2 ? 'draw' : 'lost',
        event_type: 'try_again'
      }, this.userId)

      this.open = false
      this.status = 1
      this.customerChoose = 0
      this.gameProgress = 1
      this.systemChoose = 0
      this.gameResult = 0
      this.pressed = false
      this.rockPress = true
      this.scissorPress = true
      this.paperPress = true
      this.flag = true
      this.playAudio(this.audio.start)
    },
    async goNumber() {
      // log: 知道结果之后的操作
      sendTraceLog('treat_operation', {
        ...this.traceType,
        audio_id: this.audioId,
        video_id: this.videoId,
        chapter_id: this.chapterId,
        status: this.gameResult === 2 ? 'draw' : 'lost',
        event_type: 'buy_vip'
      }, this.userId)
      // 充会员
      try {
        let url = 'ilisten:///user/vip/pur?action=treat&refer=ddcq_buy'
        if (this.audioId && +this.audioId > 0) {
          url += `&refer_obj_type=audio&refer_obj_id=${this.audioId}`
        } else if (this.videoId && +this.videoId > 0) {
          url += `&refer_obj_type=video&refer_obj_id=${this.videoId}`
        }
        await window.ibridge.callHandler('page.open', {
              url
            }, function (val) {
              if (val.code === 0) {
                window.location.href = '/exitInWebView'
              }
            }
        )
      } catch (err) {
        console.log(err)
      }
    },
    quit() {
      this.quitTraceLog()
      // 退出
      window.location.href = '/exitInWebView'
    },
    quitTraceLog() {
      // log: 知道结果之后的操作
      sendTraceLog('treat_operation', {
        ...this.traceType,
        audio_id: this.audioId,
        video_id: this.videoId,
        chapter_id: this.chapterId,
        status: this.gameResult === 2 ? 'draw' : 'lost',
        event_type: 'close'
      }, this.userId)
    },
    playAudio(url) {
      // 播放背景音乐
      try {
        window.ibridge.callHandler('player.play', {
          uri: url,
        })
      } catch (err) {
        console.log(err)
      }
    },
    async goPaySingle() {
      // log: 知道结果之后的操作
      sendTraceLog('treat_operation', {
        ...this.traceType,
        audio_id: this.audioId,
        video_id: this.videoId,
        chapter_id: this.chapterId,
        status: this.gameResult === 2 ? 'draw' : 'lost',
        event_type: 'buy_audio'
      }, this.userId)
      // 购买单一物品
      try {
        await window.ibridge.callHandler('page.open', {
              url: `ilisten:///order/payment?id=${this.goodsId}`
            }, function (val) {
              if (val.code === 0) {
                window.location.href = '/exitInWebView'
              }
            }
        )

      } catch (err) {
        console.log(err)
      }
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'userId',
      'mobile',
      'nickname',
      'avatarUrl',
      'vipCount',
      'isSub'
    ]),
    // audioId() {
    //   let str = this.$route.query.audio_ids.split('_')
    //   return str[0]
    // },
    // chapterId() {
    //   let str = this.$route.query.audio_ids.split('_')
    //   return str[1]
    // },
    /** audio 0 免费故事; 1 vip; 2 单购故事； */
    /** video 1 免费故事; 2 vip; 3 单购故事； */
    isVip() {
      return this.$route.query.vipIsFree
    },
    // goodsId() {
    //   return this.$route.query.goodID
    // }
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/fn";

.container {
  .bg("~@/assets/fingerGuess/icon-bg.png");
  min-height: 100vh;
  box-sizing: border-box;
}

.title {
  height: 156.5px;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.daidi-icon {
  width: 130px;
  height: 140px;
  position: absolute;
  left: 19px;
  bottom: 0;
  z-index: 10;
}

.daidi-ini {
  width: auto;
  height: 100%;
  .bg("~@/assets/fingerGuess/icon-daidi-ini.png");
}

.daidi-win {
  width: auto;
  height: 100%;
  .bg("~@/assets/fingerGuess/icon-daidi-win.png");
}

.daidi-lose {
  width: auto;
  height: 100%;
  .bg("~@/assets/fingerGuess/icon-daidi-lose.png");
}

.poster {
  width: 226.5px;
  height: 111px;
  .bg("~@/assets/fingerGuess/icon-poster.png");
  position: absolute;
  top: 0;
  right: 25px;
  z-index: 1;
}

.play-mechine {
  width: 100%;
  height: 477.5px;
  .bg("~@/assets/fingerGuess/play-machine.png");
  position: relative;
}

.screen {
  width: 100%;
  height: 281px;
  position: relative;
}

.screen-ini {
  width: 197px;
  height: 42.5px;
  .bg("~@/assets/fingerGuess/game-title.png");
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.error {
  height: 29px;
  width: 228px;
  font-weight: bold;
  font-size: 24px;
  color: #FFFAC0;
  letter-spacing: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.left {
  width: 107px;
  height: 103.1px;
  position: absolute;
  left: 46px;
  top: 50%;
  transform: translate(0, -50%);
}

.rock-player {
  .bg("~@/assets/fingerGuess/rock-player.png");
  width: 100%;
  height: 100%;
}

.paper-player {
  .bg("~@/assets/fingerGuess/paper-player.png");
  width: 100%;
  height: 100%;
}

.scissor-player {
  .bg("~@/assets/fingerGuess/scissor-player.png");
  width: 100%;
  height: 100%;
}

.right {
  width: 107px;
  height: 103.1px;
  right: 46px;
  top: 50%;
  position: absolute;
  transform: translate(0, -50%);
}

.rock-GM {
  .bg("~@/assets/fingerGuess/rock-gm.png");
  width: 100%;
  height: 100%;
}

.paper-GM {
  .bg("~@/assets/fingerGuess/paper-gm.png");
  width: 100%;
  height: 100%;
}

.scissor-GM {
  .bg("~@/assets/fingerGuess/scissor-gm.png");
  width: 100%;
  height: 100%;
}

.mid {
  width: 69px;
  height: 41.5px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.mid-icon {
  width: 100%;
  height: 100%;
  .bg("~@/assets/fingerGuess/icon-vs.png");
}

.rock-player-gray {
  .bg("~@/assets/fingerGuess/rock-player-gray.png");
  width: 100%;
  height: 100%;
}

.paper-player-gray {
  .bg("~@/assets/fingerGuess/paper-player-gray.png");
  width: 100%;
  height: 100%;
}

.scissor-player-gray {
  .bg("~@/assets/fingerGuess/scissor-player-gray.png");
  width: 100%;
  height: 100%;
}

.rock-result {
  width: 100%;
  height: 100%;
}

.paper-result {
  width: 100%;
  height: 100%;
}

.scissor-result {
  width: 100%;
  height: 100%;
}

.rock-GM-gray {
  .bg("~@/assets/fingerGuess/rock-gm-gray.png");
  width: 100%;
  height: 100%;
}

.paper-GM-gray {
  .bg("~@/assets/fingerGuess/paper-gm-gray.png");
  width: 100%;
  height: 100%;
}

.scissor-GM-gray {
  .bg("~@/assets/fingerGuess/scissor-gm-gray.png");
  width: 100%;
  height: 100%;
}

.result-tip {
  height: 27px;
  width: 230px;
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translate(-50%, 0);
}

.tip-win {
  width: 100%;
  height: 100%;
  .bg("~@/assets/fingerGuess/icon-win-tip.png");
  // font-size: 24px;
  // color: #FFFAC0;
  letter-spacing: 0;
  text-align: center;
}

.tip-lose {
  width: 100%;
  height: 100%;
  .bg("~@/assets/fingerGuess/icon-lose-tip.png");
  // font-size: 24px;
  // color: #FFFAC0;
  letter-spacing: 0;
  text-align: center;
}

.tip-draw {
  width: 100%;
  height: 100%;
  .bg('~@/assets/fingerGuess/icon-draw-tip.png');
  letter-spacing: 0;
  text-align: center;
}

.chooseButton {
  width: 100%;
  position: relative;
  height: 110px;
  display: flex;
  // overflow: visible;
}

.rock-button {
  height: 100%;
  flex: 1;
}

.paper-button {
  height: 100%;
  flex: 1;
}

.scissor-button {
  height: 100%;
  flex: 1;
}

.rock-unpress {
  width: 100%;
  height: 100%;
  .bg("~@/assets/fingerGuess/icon-rock-unpress.png");
}

.rock-press {
  width: 100%;
  height: 100%;
  .bg("~@/assets/fingerGuess/icon-rock-press.png");
}

.scissor-unpress {
  width: 100%;
  height: 100%;
  .bg("~@/assets/fingerGuess/icon-scissor-unpress.png");
}

.scissor-press {
  width: 100%;
  height: 100%;
  .bg("~@/assets/fingerGuess/icon-scissor-press.png");
}

.paper-unpress {
  width: 100%;
  height: 100%;
  .bg("~@/assets/fingerGuess/icon-paper-unpress.png");
}

.paper-press {
  width: 100%;
  position: relative;
  height: 110px;
  .bg("~@/assets/fingerGuess/icon-paper-press.png");
}

.result-button {
  width: 100%;
  position: relative;
  height: 110px;
}

.win-button {
  .bg("~@/assets/fingerGuess/icon-button.png");
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 88px;
  font-weight: bold;
  font-size: 24px;
  color: #604038;
  text-align: center;
}

.lose-button {
  width: 100%;
  height: 100%;
  .bg("~@/assets/fingerGuess/icon-button.png");
  text-align: center;
  line-height: 88px;
  font-weight: bold;
  font-size: 24px;
  color: #604038;
  text-align: center;
}

.lose-single-button {
  width: 100%;
  height: 100%;
  .bg("~@/assets/fingerGuess/icon-button.png");
  text-align: center;
  line-height: 88px;
  font-weight: bold;
  font-size: 24px;
  color: #604038;
  text-align: center;
}

.result-slogen {
  width: 120px;
  height: 55px;
  position: absolute;
  left: 50%;
  top: 50px;
  transform: translate(-50%, 0);
}

.win {
  width: 100%;
  height: 100%;
  .bg("~@/assets/fingerGuess/icon-win.png");
}

.equal {
  width: 100%;
  height: 100%;
  .bg("~@/assets/fingerGuess/icon-lose-one.png");
}

.lose {
  width: 100%;
  height: 100%;
  .bg("~@/assets/fingerGuess/icon-lose-two.png");
}

.quit {
  width: 48px;
  height: 33.5px;
  font-weight: bold;
  font-size: 24px;
  color: #f8e71c;
  text-align: center;
  position: relative;
  left: 50%;
  top: 34px;
  transform: translate(-50%, 0);
  text-decoration: underline;
}
</style>
